(function($){
    var clickOnList = false;

    $('body').on('input', '#search', function(){
        var input = $(this),
            query = input.val();

        if (typeof query == 'undefined' || query.length == 0) {
            input.parent().removeClass('loading');
        } else {
            input.parent().addClass('loading');
            $.post(input.parents('form').attr('action'), input.parents('form').serialize(), function(data){
                input.parents('form').find('.input-group__suggest').html(data);
            });
        }
    });

    $('body').on('blur', '#search', function(){
        setTimeout(function(){
            if (!clickOnList) {
                $('#search').parent().removeClass('loading');
            }
        }, 200);
    });

    // $('body').on('focus', '#search', function(){
    //     var input = $(this),
    //         query = input.val();
        
    //     if (typeof query != 'undefined' && query.length > 0) {
    //         input.parent().addClass('loading');
    //     }
    // });

    $('body').on('click', '.input-group__suggest__row', function(e){
        clickOnList = true;
        return true;
    });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/modules/search.js